module.exports = __webpack_public_path__ + "img/normalneet.0c48454e.png";